// extracted by mini-css-extract-plugin
export default {"modalWrapper":"Modal_modalWrapper__eOyQI","content":"Modal_content__qzYhl","close":"Modal_close__Z964F","link":"Modal_link__mh85k","linkRow":"Modal_linkRow__45NK0"};